import { render, staticRenderFns } from "./Localization.vue?vue&type=template&id=4c8cbcb9&scoped=true"
import script from "./Localization.vue?vue&type=script&lang=js"
export * from "./Localization.vue?vue&type=script&lang=js"
import style0 from "./Localization.vue?vue&type=style&index=0&id=4c8cbcb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cbcb9",
  null
  
)

export default component.exports